import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { Prompt, promptSize, promptType, SubText } from '../../components/Prompt/Prompt.component';
import { Chip, Link } from '@mui/material';
import {
  AssessmentSortBy,
  ExamTaskGroupSolutions,
  ExamTaskGroupSolutionsTableItem,
  AssignVerifierError,
  getAssignVerifierErrorLabel,
} from './Assessment.types';
import AssessmentProgressBar from './AssessmentProgressBar/AssessmentProgressBar.component';
import SendbackRGZButton from './SendbackRGZButton/SendbackRGZButton.component';
import Line from '../../assets/icons/line.svg';
import DownloadCardsIcon from '../../assets/icons/downloadCards.svg';
import { Download } from '../../components/Solution/Menu/Download.component';
import ViewContainer from '../../components/ViewContainer/ViewContainer.component';
import { useStyles } from './Assessment.styles';
import Layout from '../../components/Layout/Layout.component';
import Pagination from '../../components/Pagination.component';
import {
  ForceSelectionCallback,
  SelectableTableColumn,
  TableSelection,
} from '../../components/SelectableTable/SelectableTable.types';
import { SelectableTable } from '../../components/SelectableTable/SelectableTable.component';
import { ProgressFilter } from '../../components/SelectableTable/filters/ProgressFilter.component';
import { RangeFilter } from '../../components/SelectableTable/filters/RangeFilter.component';
import { DateFilter } from '../../components/SelectableTable/filters/DateFilter.component';
import FilterListIcon from '@material-ui/icons/FilterList';
import DropdownMenuFilter, { MenuItemWithImage } from '../../components/DropdownMenu/DropdownMenuFilter.component';
import { ReactComponent as MessageIcon } from '../../assets/icons/message.svg';
import commentOnPage from '../../assets/icons/onPageCommentIconSmall.svg';
import commentOnPageHighContrast from '../../assets/icons/onPageCommentIconSmallHighContrast.svg';
import { ReactComponent as ControlTaskIcon } from '../../assets/icons/control-task.svg';
import dIcon from '../../assets/icons/d-icon.svg';
import dIconHighContrast from '../../assets/icons/d-icon-high-contrast.svg';
import { getStatus } from './Helpers/Status.component';
import { getProgress } from './Helpers/Progress.component';
import { formatDate } from './Helpers/FormatDate.component';
import { NotificationsTableItem } from './Helpers/Notifications.component';
import { formatLink } from './Helpers/FormatLink.component';
import { HeaderCard } from './HeaderCard/HeaderCard.component';
import ActionsMenu from '../../components/ActionsMenu/ActionsMenu.component';
import { DownloadCards } from './../DownloadCards/DownloadCards.component';
import { useExaminer } from '../../Context/Examiner.context';
import {
  deleteAllExamTaskGroupSolutionAssignment,
  deleteExamTaskGroupSolutionAssignment,
  sendBackAssessedSolutions,
  setAssessmentSessionEvent,
  assignToVerifier,
} from '../../services/scoring/scoring.service';
import { AxiosResponse } from 'axios';
import { DownloadType, ExaminerFunction } from './Assessment.types';
import { DownloadExamTaskGroupSolution, ExamTaskGroupSolutionDownloadResult } from '../../models/assessment.types';
import useSessionUser from '../../hooks/useSessionUser';
import { getAssessmentQualityLabel, isExaminerBlockadeStatusForChange } from './Helpers/functionsHelpers';
import { ExaminerBlocked } from '../../components/Prompt/ExaminerBlocked.component';
import { SnackbarDownload } from '../../components/SnackbarDownload/SnackbarDownload.component';
import {
  getAssessmentSessionProcess,
  getProcessLabel,
  getNextProcess,
  redirectionToNextProcess,
  redirectionToProcess,
  processIsNotAccessible,
  isProcessEvaluationInProgres,
  updateSessionProcesses,
} from '../../utils/assessmentSessionProcess';
import { ExaminersList } from '../../components/ExaminersStructure/ExaminersStructure.types';
import { useLayoutContext } from '../../Context/Layout.context';
import {
  SendBackAssessedExamTaskGroupSolutionsResponse,
  ProcessStatus,
  SendBackResult,
  SendBackAssessedExamTaskGroupSolutionsResult,
} from '../../services/scoring/scoring.types';
import { isExaminerBlockedInSession } from '../../services/exams/examiningTeam/examiningTeam.service';
import {
  AssessmentSessionProcessTypeId,
  ExamTaskGroupSolutionStatus,
  ExamTaskGroupSolutionStatusDisablingDownloading,
  Status,
} from '../../services/exams/assessmentSession/assessments.types';
import { getSolutionTabsUrl, getSolutionUrl, Paths } from '../../utils/routerUrls';
import { ActionMenuItem } from '../../components/ActionsMenu/ActionsMenu.types';
import { getFlags } from '../../services/admin/settings/systemSettings.service';
import { ItemsFilter } from '../../components/SelectableTable/filters/ItemsFilter.component';
import { VerifierFilter } from '../../components/SelectableTable/filters/VerifierFilter.component';
import { AssignFlags } from './Modals/AssignFlags/AssignFlags.component';
import { FlagType, FlagTypes } from '../../components/SystemSettings/SystemFlags/Subcomponents/Flag.types';
import { FlagsTableItem } from '../../components/SystemSettings/SystemFlags/Subcomponents/FlagsTableItem.component';
import { FlagIcon } from '../../components/SystemSettings/SystemFlags/Subcomponents/FlagIcon.component';
import DisabledIcon from '@mui/icons-material/HideSource';
import { SampleAssessmentPill } from '../../components/SampleAssessmentPill/SampleAssessmentPill.component';
import { EvaluationSpinner } from '../../components/Assessment/EvaluationSpinner/EvaluationSpinner.component';
import { EvaluationResults } from '../../components/Assessment/EvaluationResults/EvaluationResults.component';
import { SignalRContext } from '../../Context/SignalR.context';
import { CallbackMethodNames, ExaminerProcessCompleted } from '../../models/signalR.types';
import DownloadLimitModal from './Modals/DownloadLimitModal.component';
import { SelectedRecordCountDisplay } from '../../components/SelectableTable/SelectedRecordCountDisplay/SelectedRecordCountDisplay.component';
import RemoveRGZButton from './RemoveRGZButton/RemoveRGZButton.component';
import { SessionSuspended } from '../../components/SessionSuspended/SessionSuspended.component';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import {
  unreadMessageActionType,
  UnreadMessagePrompt,
} from '../../components/Prompt/UnreadMessage/UnreadMessagePrompt.component';
import { getSheetCodeWithTaskGroupName } from '../../components/Prompt/UnreadMessage/helpers';
import { ConversationType, Priority } from '../../models/communication.types';
import { hasUnreadMessages } from '../../services/communication/communication.service';
import CardsDownloaderContainer from '../../components/CardsDownloaderContainer.component';
import { ContextualHelp } from '../../components/ContextualHelp/ContextualHelp.component';
import { RootState } from '../../store';
import { contextualHelpActions } from '../../reducers/contextualHelpReducer/contextualHelpSlice';
import Pipe from '../../assets/icons/pipe.svg';
import { assessmentSessionActions } from '../../reducers/assessmentSessionReducer/assessmentSessionSlice';
import { fillBlue, fillRed } from '../../utils/contrastSvgAttributes';
import TooltipOne from '../../components/TooltipOne/TooltipOne.component';
import { highContrastMode } from '../../utils/highContrastChecker';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssessmentQualityDropDownMenuFilters from './AssessmentQualityDropDownMenuFilters.component';
import TooltipOneComponent from '../../components/TooltipOne/TooltipOne.component';
import { IconButton, Typography } from '@material-ui/core';
import Checkbox from '../../components/Checkbox.component';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { AdvancedFilterModal } from './Modals/AdvancedFilter/AdvancedFilter.component';
import { getExamTaskWithoutRequiredCommentSubtext } from '../../components/Assessment/Footer/Helpers.component';
import { useAssessmentTableColumns } from './useAssessmentTableColumns';
import { useAssessmentTableData } from './useAssessmentTableData';
import { getVerificationStatusLabel } from './Helpers/VerificationStatus.component';
import { getAssessmentAssignmentDeleteFilterValues } from './assessmentFilters';
import { useAssessmentWorkTime } from './useAssessmentWorkTime';

interface Prompt {
  type: 'confirmation' | 'success' | 'error' | 'warning';
  mainText: string;
  subText: SubText[];
  subText2: SubText[];
  children?: React.ReactChild | React.ReactChild[];
}

const MAX_ITEMS_TO_BE_OPENED_IN_TABS = 8;

export interface AssessmentProps {
  processTypeId: AssessmentSessionProcessTypeId;
  processTypeStringId: string;
}

const Assessment: React.FC<AssessmentProps> = ({ processTypeId, processTypeStringId }: AssessmentProps) => {
  const { user: auth, userAssessmentSessionInfo, isUserPZE } = useSessionUser();
  const { isSidebarMinimized } = useLayoutContext();

  // We can do this only because the Assessment component in wrapped in AssessmentAccessGuard
  // eslint-disable-next-line
  const assessmentSession = useSelector((state: RootState) => state.assessmentSession.assessmentSession)!;
  const userFunction = userAssessmentSessionInfo.function;
  const { assessmentSessionId } = useParams() as {
    assessmentSessionId: string;
  };

  useAssessmentWorkTime({ userFunction, processTypeId });

  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { examiner, team, setForceReloadExaminersTreemap } = useExaminer();

  const [examTaskGroupSolutions, setExamTaskGroupSolutions] = useState<ExamTaskGroupSolutionsTableItem[] | null>(null);
  const [deleteConfirmationPromptOpen, setDeleteConfirmationPromptOpen] = useState<boolean>(false);
  const [
    deleteSelectedExamTaskGroupSolutionsConfirmationPromptOpen,
    setDeleteSelectedExamTaskGroupSolutionsConfirmationPromptOpen,
  ] = useState<boolean>(false);
  const [deleteSelectedExamTaskGroupSolutionsErrorPromptOpen, setDeleteSelectedExamTaskGroupSolutionsErrorPromptOpen] =
    useState<boolean>(false);
  const [deleteSelectedExamTaskGroupSolutionsInfoPromptOpen, setDeleteSelectedExamTaskGroupSolutionsInfoPromptOpen] =
    useState<boolean>(false);
  const [examTaskGroupSolutionScoresDeletedCount, setExamTaskGroupSolutionScoresDeletedCount] = useState<number>();
  const [examTaskGroupSolutionScoresNotDeletedCount, setExamTaskGroupSolutionScoresNotDeletedCount] =
    useState<number>();
  const [deleteSuccessPromptOpen, setDeleteSuccessPromptOpen] = useState<boolean>(false);
  const [deleteErrorPromptOpen, setDeleteErrorPromptOpen] = useState<boolean>(false);
  const [isTeamList, setIsTeamList] = useState<boolean>(false);
  const [sendbackPromptOpen, setSendbackPromptOpen] = useState<boolean>(false);
  const [sendbackPromptSize, setSendbackPromptSize] = useState<promptSize | undefined>(undefined);
  const [sendbackPromptType, setSendbackPromptType] = useState<promptType>('success');
  const [sendbackPromptMainText, setSendbackPromptMainText] = useState<React.ReactNode>('');
  const [sendbackPromptSubTexts, setSendbackPromptSubTexts] = useState<SubText[]>([]);
  const [mainActionButtonText, setMainActionButtonText] = useState<string>('');
  const [mainActionButtonCallback, setMainActionButtonCallback] = useState<(() => void) | null>(null);
  const [currentActionOrgz, setCurrentActionOrgz] = useState<ExamTaskGroupSolutions | null>(null);
  const [isSnackbarVisible, setIsSnackbarVisible] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [isExaminerBlockedPromptOpen, setIsExaminerBlockedPromptOpen] = useState<boolean>(false);
  const { openAlert, showLoader } = useLayoutContext();
  const [flags, setFlags] = useState<FlagType[]>([]);
  const [assignFlagsOpen, setAssignFlagsOpen] = useState<boolean>(false);
  const [isListening, setIsListening] = useState<boolean>(false);
  const [downloadLimitModalOpen, setDownloadLimitModalOpen] = useState<boolean>(false);
  const [itemsSelection, setItemsSelection] = useState<TableSelection>({ items: [] });
  const [onForceSelectionCallback, setOnForceSelectionCallback] = useState<ForceSelectionCallback | undefined>(
    undefined,
  );
  const [unreadMessagePrompt, setUnreadMessagePrompt] = useState<{
    isOpen: boolean;
    actionType: unreadMessageActionType;
    unreadConversationType: ConversationType;
  }>({ isOpen: false, actionType: 'download', unreadConversationType: ConversationType.Standard });

  const [tooManyItemsToBeOpenedInTabsErrorOpened, setTooManyItemsToBeOpenedInTabsErrorOpened] =
    useState<boolean>(false);
  const isAllowedToFilterAssessmentQuality = userFunction !== ExaminerFunction.CZE;
  const [enhancedText, setEnhancedText] = useState<JSX.Element>(<div></div>);
  const [isValidationFailedForVerifierPromptOpen, setIsValidationFailedForVerifierPromptOpen] =
    useState<boolean>(false);
  const [isSuccessVerifierAssignedPromptOpen, setIsSuccessVerifierAssignedPromptOpen] = useState<boolean>(false);
  const [verifier, setVerifier] = useState<ExaminersList | null>(null);
  const [assignedToVerifier, setAssignedToVerifier] = useState<number>(0);
  const [validationErrorMessage, setValidationErrorMessage] = useState<SubText[]>([]);

  const {
    filter,
    statusFilter,
    assessmentQualityFilter,
    filterState,
    pageInfo,
    advancedFilter,
    isResetAdvancedFilter,
    setIsResetAdvancedFilter,
    checkedTasks,
    setCheckedTasks,
    checkedCriterions,
    setCheckedCriterions,
    sortByColumnId,
    setSortByColumnId,
    isDescending,
    setIsDescending,
    handleFilterChange,
    handleNoAnswerFilterChange,
    refreshData,
    examTaskGroupSolutionsData,
    refreshStatusOfSentbackAssessedExamTaskGroupSolutionScores,
    setExceptionalSendbackCaseFailure,
    setAdvancedFilterModalOpen,
    progressBarData,
    examinerHasScoreToSendback,
    handleStatusFilterChange,
    handleAssessmentQualityFilterChange,
    uncheckFilterItem,
    uncheckAllFilters,
    getAssessment,
    advancedFilterModalOpen,
    handleAdvancedFilterChange,
    setIsExaminerBlocked,
    setIsEmptyList,
    isExaminerBlocked,
    isEmptyList,
    setExamTaskGroupSolutionStatus,
    examTaskGroupSolutionStatus,
    assessmentSessionStateId,
    onAdvancedFilterReset,
    checkExamTaskGroupSolutionStatus,
  } = useAssessmentTableData({ assessmentSession, examiner, processTypeStringId, processTypeId, userFunction, auth });

  const hasAnyRealExamTaskGroupSolutions = useMemo(() => {
    if (!progressBarData) {
      return false;
    }
    const { assessedTaskGroupSolutions, closedTaskGroupSolutions, newTaskGroupSolutions, openTaskGroupSolutions } =
      progressBarData;
    return assessedTaskGroupSolutions + closedTaskGroupSolutions + newTaskGroupSolutions + openTaskGroupSolutions > 0;
  }, [progressBarData]);
  const isVerifierInScoringProcess =
    !!userAssessmentSessionInfo?.isVerifier && processTypeId === AssessmentSessionProcessTypeId.Scoring;

  const getVerificatorFromPZEInferiors = () => {
    if (examiner && examiner.function === ExaminerFunction.PZE) {
      if (examiner.inferiors.length) {
        const veficatorRole = examiner.inferiors.filter((i) => i.examiner?.examinerPermission?.isVerifier);
        return veficatorRole[0] ? veficatorRole[0] : null;
      }
    }
    return null;
  };

  useEffect(() => {
    getFlags().then(
      (result: FlagType[]) => setFlags(result),
      () => openAlert('get_error'),
    );
  }, []);

  useEffect(() => {
    if (examiner && examiner.function !== undefined) {
      switch (examiner.function) {
        case ExaminerFunction.CZE:
          setIsTeamList(false);
          break;
        default:
          setIsTeamList(true);
          break;
      }

      const verifier = getVerificatorFromPZEInferiors();
      setVerifier(verifier);
    }
  }, [examiner]);

  const getExaminerName = () => {
    if (examiner && examiner.examiner) {
      return examiner.examiner.displayName;
    } else {
      return undefined;
    }
  };

  const getExaminerNameById = (element: ExaminersList, search: string): ExaminersList | null => {
    if (element.examiner && element.examiner.id.includes(search.toLowerCase())) {
      return element;
    } else if (element.inferiors.length) {
      for (let i = 0; i < element.inferiors.length; i++) {
        const match = getExaminerNameById(element.inferiors[i], search);
        if (match) {
          return {
            examiner: match.examiner,
            inferiors: [],
            function: match.function,
            id: match.id,
          };
        }
      }
    }
    return null;
  };

  const getcurrentActionOrgzExaminerName = () => {
    if (team && currentActionOrgz) {
      const examiners = getExaminerNameById(team, currentActionOrgz.examinerId);
      return examiners?.examiner?.displayName ?? '';
    } else return '';
  };

  const { columns } = useAssessmentTableColumns({ userFunction, isVerifier: isVerifierInScoringProcess });

  const columnsForExaminer: SelectableTableColumn[] = columns.map((column) => {
    if (column.id === 'examinerName') {
      return {
        ...column,
        style: {
          display: 'none',
        },
      };
    } else {
      return { ...column };
    }
  });

  const onRemoveRGZAssignmentSuccess = (onSuccess: AxiosResponse) => {
    if (onSuccess.data) {
      setExamTaskGroupSolutionScoresDeletedCount(onSuccess.data.examTaskGroupSolutionScoresDeletedCount);
      setExamTaskGroupSolutionScoresNotDeletedCount(onSuccess.data.examTaskGroupSolutionScoresNotDeletedCount);
      if (onSuccess.data.examTaskGroupSolutionScoresNotDeletedCount === 0) {
        onForceSelectionCallback && onForceSelectionCallback({ items: [] });
        setDeleteSelectedExamTaskGroupSolutionsInfoPromptOpen(true);
      } else if (onSuccess.data.examTaskGroupSolutionScoresDeletedCount === 0) {
        setDeleteSelectedExamTaskGroupSolutionsErrorPromptOpen(true);
      } else {
        setDeleteSelectedExamTaskGroupSolutionsInfoPromptOpen(true);
      }
    }
  };

  const onRemoveRGZAssignmentError = () => setDeleteSelectedExamTaskGroupSolutionsErrorPromptOpen(true);

  const removeAllRGZAssignment = () => {
    if (examiner && processTypeId) {
      const filters = getAssessmentAssignmentDeleteFilterValues(filter);
      deleteAllExamTaskGroupSolutionAssignment(
        examiner.id,
        examiner.function.toString(),
        processTypeId.toString(),
        ...(filters as string[]),
      )
        .then(onRemoveRGZAssignmentSuccess, onRemoveRGZAssignmentError)
        .finally(() => showLoader(false));
    }
  };

  const removeMultipleRGZAssignment = () => {
    showLoader(true, 'Usuwanie kart');
    if (itemsSelection.isAll) {
      removeAllRGZAssignment();
    } else {
      if (examiner) {
        deleteExamTaskGroupSolutionAssignment(itemsSelection.items)
          .then(onRemoveRGZAssignmentSuccess, onRemoveRGZAssignmentError)
          .finally(() => showLoader(false));
      }
    }
  };

  const removeCurrentRGZAssignment = () => {
    if (!currentActionOrgz) return;
    if (examiner) {
      deleteExamTaskGroupSolutionAssignment([currentActionOrgz.examTaskGroupSolutionScoreId]).then(
        (onSuccess) => {
          onForceSelectionCallback && onForceSelectionCallback({ items: [] });
          onSuccess.data ? setDeleteSuccessPromptOpen(true) : setDeleteErrorPromptOpen(true);
        },
        () => setDeleteErrorPromptOpen(true),
      );
    }
  };

  const canDisplayRemoveAssignment = (): boolean => {
    return userFunction !== undefined && [ExaminerFunction.KK, ExaminerFunction.KGZ].includes(userFunction);
  };
  const canModifyFlags = (): boolean => {
    return userFunction !== undefined && [ExaminerFunction.CZE, ExaminerFunction.PZE].includes(userFunction);
  };

  const disableIcon = (isDisabled: boolean): JSX.Element | undefined => {
    return isDisabled ? <DisabledIcon style={{ marginRight: '5px', fontSize: '1rem' }} /> : undefined;
  };
  const getActionsMenuIcon = (orgz: ExamTaskGroupSolutions, rowIndex: number): JSX.Element => {
    const menuItems: ActionMenuItem[] = [];
    if (canDisplayRemoveAssignment()) {
      menuItems.push({
        text: 'Usuń przypisanie RGZ',
        disabled: [Status.Assessed, Status.Closed].includes(orgz.status),
        icon: disableIcon([Status.Assessed, Status.Closed].includes(orgz.status)),
        onClick: () => setDeleteConfirmationPromptOpen(true),
      });
      if (canModifyFlags() && flags.some((flag) => flag.active)) {
        menuItems.push({
          text: 'Wybierz znacznik flagi',
          onClick: () => setAssignFlagsOpen(true),
        });
      }
      return <ActionsMenu onOpen={() => setCurrentActionOrgz(orgz)} menuItems={menuItems} rowIndex={rowIndex} />;
    } else return <></>;
  };

  const onExamTaskGroupSolutionsDownload = () => {
    setIsEmptyList(false);
    checkExamTaskGroupSolutionStatus();
    refreshData(true);
  };

  const checkUnreadMessages = (action: unreadMessageActionType) => {
    hasUnreadMessages(Priority.High)
      .then((result) => {
        if (result.status === 200) {
          setUnreadMessagePrompt({
            isOpen: true,
            actionType: action,
            unreadConversationType: result.data,
          });
        }
      })
      .catch(() => openAlert('get_error'));
  };

  const handleDownloadFinish = async (downloadType: DownloadType, response: DownloadExamTaskGroupSolution) => {
    switch (response.solutionDownloadResult) {
      case ExamTaskGroupSolutionDownloadResult.NoneExceededLimits:
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneExceededLimits);
        setDownloadLimitModalOpen(true);
        break;
      case ExamTaskGroupSolutionDownloadResult.NoneNoMoreSolutions:
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneNoMoreSolutions);
        setDownloadLimitModalOpen(true);
        break;
      case ExamTaskGroupSolutionDownloadResult.NoneExaminerBlocked:
        setIsExaminerBlocked(true);
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneExaminerBlocked);
        setIsExaminerBlockedPromptOpen(true);
        setForceReloadExaminersTreemap(true);
        break;
      //TODO-button is going to be disabled with tooltip
      case ExamTaskGroupSolutionDownloadResult.NoneProcessFinished:
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneProcessFinished);
        break;
      case ExamTaskGroupSolutionDownloadResult.ExaminerShouldReadMessages:
        checkUnreadMessages('download');
        break;

      default:
        setIsSnackbarVisible(true);
        setSnackbarMessage(
          downloadType === DownloadType.fillToLimits ? `Pobrano ${response.solutions.length} kart` : 'Karta pobrana',
        );
        onExamTaskGroupSolutionsDownload();
        break;
    }
  };

  const redirectToNextProcess = async () => {
    if (!examiner || !examiner.examiner) throw new Error('no examiner!');
    if (!!!assessmentSession?.assessmentSessionId) return;
    const updatedSession = await updateSessionProcesses(assessmentSession?.assessmentSessionId);
    dispatch(assessmentSessionActions.updateAssessmentSession(updatedSession));

    redirectionToNextProcess(
      assessmentSession?.assessmentSessionId,
      examiner.examiner.id,
      undefined,
      updatedSession,
    ).then((data) => {
      setIsEmptyList(true);
      if (
        assessmentSession.examinerFunction === ExaminerFunction.PZE &&
        data.nextProcess === AssessmentSessionProcessTypeId.Scoring
      ) {
        //After evaluation PZE needs to go back to the dashboard to have tokens reloaded
        history.push(Paths.dashboard);
      } else if (data && data.url) {
        if (data.nextProcess === AssessmentSessionProcessTypeId.Scoring) {
          setAssessmentSessionEvent(1).then(() => {
            sessionStorage.setItem('startWork', 'true');
            setSendbackPromptOpen(false);
            history.push(data.url);
            setMainActionButtonCallback(null);
          });
        } else {
          setSendbackPromptOpen(false);
          history.push(data.url);
          setMainActionButtonCallback(null);
        }
      }
    });
  };

  const setSendBackPrompt = (
    size: promptSize | undefined,
    type: promptType,
    mainText: React.ReactNode,
    mainActionButtonText: string,
    subTexts: SubText[],
    mainButtonClickCallback: (() => void) | null,
  ) => {
    setSendbackPromptSize(size);
    setSendbackPromptType(type);
    setSendbackPromptMainText(mainText);
    setMainActionButtonText(mainActionButtonText);
    setSendbackPromptSubTexts(subTexts);
    setMainActionButtonCallback(mainButtonClickCallback ? () => () => mainButtonClickCallback() : null);
  };

  const notAdmittedSendbackCases = (
    resultsArray: SendBackAssessedExamTaskGroupSolutionsResult[],
    notAdmittedToScoringProcess: boolean,
  ) => {
    if (resultsArray[0].sendBackResult === SendBackResult.Success && !notAdmittedToScoringProcess) {
      setSendbackPromptSize(undefined);
      setSendbackPromptType('success');
      setSendbackPromptMainText(`RGZ: ${resultsArray[0].examTaskGroupSolutionScoreId}`);
      setSendbackPromptSubTexts([{ text: 'Zostało pomyślnie odesłane.' }]);
      setMainActionButtonText('Powrót do listy');
      refreshStatusOfSentbackAssessedExamTaskGroupSolutionScores(
        [resultsArray[0].examTaskGroupSolutionScoreId],
        resultsArray[0].examTaskSolutionStatus,
      );
    } else if (notAdmittedToScoringProcess && processTypeId === AssessmentSessionProcessTypeId.Qualification) {
      setSendbackPromptSize(undefined);
      setSendbackPromptType('error');
      setSendbackPromptMainText('Nie zostałeś/łaś zakwalifikowany/a do procesu oceniania');
      setSendbackPromptSubTexts([]);
      setMainActionButtonText('Powrót do listy');
      refreshStatusOfSentbackAssessedExamTaskGroupSolutionScores(
        [resultsArray[0].examTaskGroupSolutionScoreId],
        resultsArray[0].examTaskSolutionStatus,
      );
    } else {
      setSendbackPromptSize(undefined);
      setSendbackPromptType('error');
      setSendbackPromptMainText(
        `Wysyłanie ${
          resultsArray.length === 1 ? 'ocenionego' : 'ocenionych'
        } RGZ nie powiodło się, spróbuj ponownie później`,
      );
      if (resultsArray[0].sendBackResult === SendBackResult.FailedSpecialCase) {
        setExceptionalSendbackCaseFailure([resultsArray[0].examTaskGroupSolutionScoreId]);
      }
      if (resultsArray[0].sendBackResult === SendBackResult.FailedMissingComments) {
        const subtext = getExamTaskWithoutRequiredCommentSubtext(resultsArray[0].examTasksWithoutRequiredComment);
        setEnhancedText(subtext);
        setSendbackPromptMainText('Nie można odesłać ocenionego RGZ, ponieważ nie został wprowadzony komentarz do:');
      }
    }
    setSendbackPromptOpen(true);
  };

  const getCounters = (
    result: SendBackAssessedExamTaskGroupSolutionsResult[],
  ): { success: number; failedSpecialCase: number } => {
    return {
      success: result.filter((item) => item.sendBackResult === SendBackResult.Success).length,
      failedSpecialCase: result.filter((item) => item.sendBackResult === SendBackResult.FailedSpecialCase).length,
    };
  };

  const updatePromptWithEvaluationResults = (
    evaluationSucceeded: boolean,
    nextProcessId?: AssessmentSessionProcessTypeId,
  ) => {
    setSendbackPromptMainText('');
    setSendbackPromptSubTexts([
      {
        text: (
          <EvaluationResults
            succeeded={evaluationSucceeded}
            nextProcessId={
              nextProcessId !== undefined ? nextProcessId : getNextProcess(processTypeId, getAssessmentSessionProcess())
            }
            onSuccessButtonClick={redirectToNextProcess}
          />
        ),
      },
    ]);
  };

  SignalRContext.useSignalREffect(
    CallbackMethodNames.ExaminerCurrentProcessCompleted,
    (message: ExaminerProcessCompleted) => {
      updatePromptWithEvaluationResults(message.succeeded, message.nextProcess);
      setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.Available);
    },
    [isListening],
  );

  SignalRContext.useSignalREffect(
    CallbackMethodNames.ExaminerUnblocked,
    (message) => {
      if (examiner && isExaminerBlockadeStatusForChange(assessmentSession, examiner, message, auth.profile?.sub)) {
        setIsExaminerBlocked(false);
        checkExamTaskGroupSolutionStatus();
        console.log('___processTypeId: ', processTypeId);
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.Available);
        if (processTypeId === AssessmentSessionProcessTypeId.Qualification) {
          redirectToNextProcess();
        }
      }
    },
    [examiner],
  );

  SignalRContext.useSignalREffect(
    CallbackMethodNames.ExaminerBlocked,
    (message) => {
      if (examiner && isExaminerBlockadeStatusForChange(assessmentSession, examiner, message, auth.profile?.sub)) {
        setIsExaminerBlocked(true);
        setExamTaskGroupSolutionStatus(ExamTaskGroupSolutionStatus.NoneExaminerBlocked);
      }
    },
    [examiner],
  );

  const getSendbackFailedRGZLinksOfType = (
    result: SendBackAssessedExamTaskGroupSolutionsResult[],
    failureType: SendBackResult,
    examiner: ExaminersList,
  ): {
    inlineLink: JSX.Element;
  }[] => {
    return result
      .filter((item) => item.sendBackResult === failureType)
      .map((item) => {
        return {
          inlineLink: formatLink(
            item.examTaskGroupSolutionScoreId,
            item.examinerId,
            processTypeStringId,
            examiner.id,
            examiner.function.toString(),
          ),
        };
      });
  };

  const getFailedSendbackTexts = (
    failedSpecialCaseLinks: {
      inlineLink: JSX.Element;
    }[],
    failedMissingCommentsLinks: {
      inlineLink: JSX.Element;
    }[],
  ): SubText[] => {
    const subTexts: SubText[] = [];
    if (failedSpecialCaseLinks.length > 0) {
      subTexts.push(
        ...[
          { text: 'RGZ:' },
          ...failedSpecialCaseLinks,
          {
            text: `Nie ${
              failedSpecialCaseLinks.length === 1 ? 'może' : 'mogą'
            } zostać wysłane ze względu na zgłoszony szczególny przypadek.`,
          },
        ],
      );
    }
    if (failedMissingCommentsLinks.length > 0) {
      subTexts.push(
        ...[
          { text: 'RGZ:' },
          ...failedMissingCommentsLinks,
          {
            text: `Nie ${
              failedMissingCommentsLinks.length === 1 ? 'może' : 'mogą'
            } zostać wysłane ze względu na brakujące wymagane komentarze.`,
          },
        ],
      );
    }
    return subTexts;
  };

  const handleSendbackAssessedSolutions = useCallback(
    (solutionIds: string[]) => {
      if (examiner) {
        showLoader(true, 'Wysyłanie danych');
        sendBackAssessedSolutions(solutionIds)
          .then(
            async (result: AxiosResponse<SendBackAssessedExamTaskGroupSolutionsResponse>) => {
              const resultsArray = result.data.results;
              const processStatus = result.data.processStatus;
              if (processStatus === ProcessStatus.ExaminerShouldReadMessages) {
                checkUnreadMessages('sendback');
              } else {
                const processHasFinished = processStatus === ProcessStatus.Completed;
                const evaluationInProgress = isProcessEvaluationInProgres(processStatus);
                const notAdmittedToScoringProcess = processStatus === ProcessStatus.Failed;
                const nextProcessId: AssessmentSessionProcessTypeId | null = processHasFinished
                  ? getNextProcess(processTypeId, getAssessmentSessionProcess())
                  : null;

                if (evaluationInProgress) setIsListening(true);

                if (solutionIds.length === 1) {
                  //single
                  if (resultsArray[0].sendBackResult === SendBackResult.Success && evaluationInProgress) {
                    setSendBackPrompt(
                      'xs',
                      'info',
                      `Ostatnie RGZ z pobranych w ${getProcessLabel(processTypeId).inProcess} zostało odesłane`,
                      'Powrót do listy',
                      [
                        {
                          text: <EvaluationSpinner />,
                          fontSize: 16,
                        },
                      ],
                      null,
                    );
                    setEnhancedText(<div></div>);
                    refreshStatusOfSentbackAssessedExamTaskGroupSolutionScores(
                      [resultsArray[0].examTaskGroupSolutionScoreId],
                      resultsArray[0].examTaskSolutionStatus,
                    );
                    setSendbackPromptOpen(true);
                  } else notAdmittedSendbackCases(resultsArray, notAdmittedToScoringProcess);
                } else {
                  //multiple
                  const counters = getCounters(resultsArray);
                  const failedSpecialCaseLinks = getSendbackFailedRGZLinksOfType(
                    resultsArray,
                    SendBackResult.FailedSpecialCase,
                    examiner,
                  );
                  const failedMissingCommentsLinks = getSendbackFailedRGZLinksOfType(
                    resultsArray,
                    SendBackResult.FailedMissingComments,
                    examiner,
                  );
                  const failedSendbackRGZText = getFailedSendbackTexts(
                    failedSpecialCaseLinks,
                    failedMissingCommentsLinks,
                  );
                  if (
                    counters.success > 0 &&
                    counters.success === resultsArray.length &&
                    processTypeId !== AssessmentSessionProcessTypeId.Scoring &&
                    (evaluationInProgress || processHasFinished) &&
                    nextProcessId
                  ) {
                    setSendBackPrompt(
                      'xs',
                      'info',
                      <>
                        <div>
                          {counters.success} z {resultsArray.length}
                        </div>
                        <div>
                          Wszystkie RGZ w {getProcessLabel(processTypeId).inProcess} zostały pomyślnie odesłane.
                        </div>
                      </>,
                      'Powrót do listy',
                      evaluationInProgress
                        ? [
                            {
                              text: <EvaluationSpinner />,
                              fontSize: 16,
                            },
                          ]
                        : [],
                      null,
                    );
                  } else if (
                    counters.success > 0 &&
                    counters.success === resultsArray.length &&
                    !notAdmittedToScoringProcess
                  ) {
                    setSendbackPromptSize(undefined);
                    setSendbackPromptType('success');
                    setSendbackPromptMainText(`${counters.success} z ${resultsArray.length}`);
                    setSendbackPromptSubTexts([{ text: 'Rozwiązania Grupy Zadań zostały pomyślnie odesłane.' }]);
                    setMainActionButtonText('Powrót do listy');
                    setEnhancedText(<div></div>);
                  } else if (
                    counters.success > 0 &&
                    counters.success < resultsArray.length &&
                    processTypeId === AssessmentSessionProcessTypeId.Scoring
                  ) {
                    setSendbackPromptSize(undefined);
                    setSendbackPromptType('confirmation');
                    setSendbackPromptMainText(`${counters.success} z ${resultsArray.length}`);
                    setSendbackPromptSubTexts([
                      { text: 'Rozwiązania Grupy Zadań zostały pomyślnie odesłane.' },
                      ...failedSendbackRGZText,
                    ]);
                    setMainActionButtonText('Powrót do listy');
                    setEnhancedText(<div></div>);
                  } else if (
                    counters.success > 0 &&
                    counters.success < resultsArray.length &&
                    processTypeId !== AssessmentSessionProcessTypeId.Scoring
                  ) {
                    setSendbackPromptSize(undefined);
                    setSendbackPromptType('confirmation');
                    setSendbackPromptMainText(`${counters.success} z ${resultsArray.length}`);
                    setSendbackPromptSubTexts([
                      { text: 'Rozwiązania Grupy Zadań zostały pomyślnie odesłane.' },
                      ...failedSendbackRGZText,
                    ]);
                    setMainActionButtonText('Powrót do listy');
                    setEnhancedText(<div></div>);
                  } else if (counters.success === 0 && counters.failedSpecialCase === resultsArray.length) {
                    setSendbackPromptSize(undefined);
                    setSendbackPromptType('confirmation');
                    setSendbackPromptMainText(`${counters.success} z ${resultsArray.length}`);
                    setSendbackPromptSubTexts([...failedSendbackRGZText]);
                    setMainActionButtonText('Powrót do listy');
                  } else if (
                    notAdmittedToScoringProcess &&
                    processTypeId === AssessmentSessionProcessTypeId.Qualification
                  ) {
                    setSendbackPromptSize(undefined);
                    setSendbackPromptType('error');
                    setSendbackPromptMainText('Nie zostałeś/łaś zakwalifikowany/a do procesu oceniania');
                    setMainActionButtonText('Powrót do listy');
                    setEnhancedText(<div></div>);
                  } else if (counters.success === 0 && resultsArray.length === 0) {
                    setSendbackPromptSize(undefined);
                    setSendbackPromptType('confirmation');
                    setSendbackPromptMainText('W tej chwili nie masz żadnych ocenionych RGZ do odesłania.');
                    setEnhancedText(<div></div>);
                  }
                  if (counters.success > 0) {
                    refreshStatusOfSentbackAssessedExamTaskGroupSolutionScores(
                      resultsArray
                        .filter((item) => item.sendBackResult === SendBackResult.Success)
                        .map((item) => item.examTaskGroupSolutionScoreId),
                      resultsArray[0].examTaskSolutionStatus,
                    );
                  }
                  if (counters.failedSpecialCase > 0) {
                    setExceptionalSendbackCaseFailure(
                      resultsArray
                        .filter((item) => item.sendBackResult === SendBackResult.FailedSpecialCase)
                        .map((item) => item.examTaskGroupSolutionScoreId),
                    );
                  }
                  if (resultsArray.length) {
                    setSendbackPromptSize(undefined);
                    setSendbackPromptType('success');
                    setSendbackPromptMainText(`${counters.success} z ${resultsArray.length}`);
                    setSendbackPromptSubTexts([
                      { text: 'Rozwiązania Grupy Zadań zostały pomyślnie odesłane.' },
                      ...failedSendbackRGZText,
                    ]);
                    setMainActionButtonText('Powrót do listy');
                    setEnhancedText(<div></div>);
                  }
                  setSendbackPromptOpen(true);
                }
              }
            },
            () => {
              setSendbackPromptSize(undefined);
              setSendbackPromptType('error');
              setSendbackPromptMainText(
                `Wysyłanie ${
                  solutionIds.length === 1 ? 'ocenionego' : 'ocenionych'
                } RGZ nie powiodło się, spróbuj ponownie później`,
              );
              setSendbackPromptOpen(true);
              setEnhancedText(<div></div>);
            },
          )
          .finally(() => {
            showLoader(false);
            refreshData(true);
          });
      }
    },
    [examiner],
  );

  const handleRemoveRGZFunction = () => {
    setDeleteSelectedExamTaskGroupSolutionsConfirmationPromptOpen(true);
  };

  const createOnClickElement = (firstName: string, lastName: string) => {
    return (
      <TooltipOne placement="top" title={`${firstName} ${lastName}`}>
        <Link
          component="button"
          variant="body2"
          style={{ color: '#3C419A', textDecorationColor: '#3C419A' }}
          onClick={() => handleFilterChange('examinerName', firstName + ' ' + lastName)}
        >
          {firstName?.charAt(0) + '. ' + lastName}
        </Link>
      </TooltipOne>
    );
  };

  //MAP response from API to Table DTO
  useEffect(() => {
    if (examiner && examTaskGroupSolutionsData) {
      const transformedData: ExamTaskGroupSolutionsTableItem[] = examTaskGroupSolutionsData.map(
        (orgz: ExamTaskGroupSolutions, index) => {
          let tresholdTooltip = undefined;
          if (
            orgz.finalAssessmentQuality !== null &&
            orgz.sampleAssessmentPoints !== null &&
            orgz.status === Status.Closed
          ) {
            tresholdTooltip = getAssessmentQualityLabel(orgz.finalAssessmentQuality.toString(), processTypeId);
          }

          return {
            flag: (
              <FlagsTableItem
                flags={orgz.examTaskGroupSolutionScoreFlags}
                allAvailableFlags={flags}
                examTaskGroupSolutionScoreId={orgz.examTaskGroupSolutionScoreId}
                onSave={refreshData}
                rowIndex={index}
              />
            ),
            tableEnterURL: getSolutionUrl(
              orgz.examTaskGroupSolutionScoreId,
              orgz.examinerId,
              processTypeStringId,
              examiner.id,
              examiner.function.toString(),
              orgz.tasksSolutionSheetId,
            ),
            examTaskGroupSolutionScoreId: formatLink(
              orgz.examTaskGroupSolutionScoreId,
              orgz.examinerId,
              processTypeStringId,
              examiner.id,
              examiner.function.toString(),
              orgz.tasksSolutionSheetId,
            ),
            status: getStatus(orgz.status),
            examinerName: createOnClickElement(orgz.firstName, orgz.lastName),
            pointsSum: (
              <>
                {orgz.sampleAssessmentPoints !== null && orgz.status === Status.Closed ? (
                  <SampleAssessmentPill
                    sampleAssessmentPoints={orgz.pointsSum}
                    assessmentQuality={orgz.finalAssessmentQuality}
                    tooltip={tresholdTooltip}
                    processTypeId={processTypeId}
                  />
                ) : orgz.progress ? (
                  orgz.pointsSum
                ) : (
                  <></>
                )}
                {orgz.examTaskNumbersWithNoAnswer.length > 0 && (
                  <TooltipOneComponent
                    title={`Brak odpowiedzi w zadaniu: ${orgz.examTaskNumbersWithNoAnswer.join(', ')}`}
                    placement="top"
                  >
                    <Chip
                      style={{
                        color: '#000000',
                        borderColor: '#000000',
                        justifyContent: 'center',
                        marginLeft: '8px',
                      }}
                      key={'BO'}
                      label={'BO'}
                      variant="outlined"
                      size="small"
                    />
                  </TooltipOneComponent>
                )}
              </>
            ),
            sampleAssessmentPoints: orgz.sampleAssessmentPoints,
            progress: getProgress(
              orgz.progress,
              orgz.status,
              orgz.examinerId,
              [orgz.examTaskGroupSolutionScoreId],
              handleSendbackAssessedSolutions,
              orgz.isSpecialCase,
              examTaskGroupSolutionStatus === ExamTaskGroupSolutionStatus.NoneSessionClosed,
            ),
            alerts: (
              <NotificationsTableItem
                warnings={orgz.isSpecialCase}
                emails={orgz.withMessage}
                isControlProcessType={orgz.isControlProcessType}
                isScoringAdjusted={orgz.isScoringAdjusted}
                isCommentOnCriteria={orgz.isCommentOnCriteria}
                isCommentOnImage={orgz.isCommentOnImage}
                isCommentOffPage={orgz.isCommentOffPage}
                changedScoreInfo={orgz.changedScoreInfo}
                closedSpecialCase={orgz.hasClosedSpecialCase}
              />
            ),
            verifier: getVerificationStatusLabel(orgz.verificationState, userFunction ?? ExaminerFunction.PZE),
            downloadDate: formatDate(new Date(orgz.downloadDate)),
            updateDate: orgz.updateDate ? formatDate(new Date(orgz.updateDate)) : <></>,
            id: orgz.examTaskGroupSolutionScoreId,
            actions: getActionsMenuIcon(orgz, index),
          };
        },
      );
      setExamTaskGroupSolutions(transformedData);
    }
  }, [examTaskGroupSolutionsData, examiner]);

  const [anchorElStatus, setAnchorElStatus] = useState<SVGSVGElement | HTMLElement | null>(null);
  const [anchorElAlert, setAnchorElAlert] = useState<SVGSVGElement | HTMLElement | null>(null);

  const handleClickStatus = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (!anchorElStatus) {
      setAnchorElStatus(event.currentTarget);
    } else setAnchorElStatus(null);
  };

  const handleClickAlert = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (!anchorElAlert) {
      setAnchorElAlert(event.currentTarget);
    } else setAnchorElAlert(null);
  };

  const flagsFilter: MenuItemWithImage<string>[] = FlagTypes.map((flag) => ({
    text: flag.name,
    jsxElement: <FlagIcon id={flag.id} name={flag.name} color={flag.color} />,
  }));

  const getAlertsMenuItems = () => {
    const alertsMenuItems = [
      {
        value: '1',
        text: 'Komentarz do kryterium',
        jsxElement: (
          <div className={classes.roundSmallBlue}>
            <SpeakerNotesIcon style={{ color: 'white', marginTop: '5px', width: '0.5em', height: '0.5em' }} />
          </div>
        ),
      },
      {
        value: '2',
        text: 'Komentarz na stronie',
        imagePath: `${highContrastMode ? commentOnPageHighContrast : commentOnPage}`,
      },
      {
        value: '3',
        text: 'Komentarz poza stroną',
        jsxElement: (
          <div className={classes.roundSmallPink}>
            <RateReviewOutlinedIcon style={{ color: 'white', marginTop: '5px', width: '0.5em', height: '0.5em' }} />
          </div>
        ),
      },
      {
        value: '4',
        text: 'Nierozstrzygnięty szczególny przypadek',
        jsxElement: <ErrorOutlineIcon style={{ color: fillRed, marginTop: '5px' }} />,
      },
      {
        value: '5',
        text: 'Zamknięty szczególny przypadek',
        jsxElement: (
          <div style={{ marginLeft: '-1px' }}>
            <ErrorOutlineIcon style={{ color: fillRed }} />
            <CheckCircleIcon
              style={{ position: 'absolute', left: '55px', top: '20px', width: '5%', height: 'auto', color: 'green' }}
            />
          </div>
        ),
      },
      { value: '6', text: 'Zadanie Kontrolne', jsxElement: <ControlTaskIcon fill={fillBlue} /> },
      {
        value: '7',
        text: 'Dostosowane zasady oceniania',
        imagePath: `${highContrastMode ? dIconHighContrast : dIcon}`,
      },
      {
        value: '8',
        text: 'Ocena zmieniona (KK, KGZ)',
        jsxElement: <PublishedWithChangesIcon fontSize="small" style={{ color: '#316394' }} />,
      },
      {
        value: '9',
        text: 'Wiadomość',
        jsxElement: <MessageIcon fill={fillBlue} style={{ width: '120%', height: 'auto', marginTop: '4px' }} />,
      },
    ];

    if (userFunction === ExaminerFunction.CZE) {
      return alertsMenuItems.filter((e) => e.text !== 'Zadanie Kontrolne');
    } else return alertsMenuItems;
  };

  const isAdvancedFilter = advancedFilter !== null && checkedTasks.length > 0 && !isResetAdvancedFilter;

  const filterElements: { [key: string]: JSX.Element } = {
    status: (
      <>
        <TooltipOne title="Ustaw filtr do wyszukiwania: Status" placement="top">
          <IconButton disableRipple aria-label={`Ikonka rozwijająca filtr do wyszukiwania: Status`} size="small">
            <FilterListIcon
              className={statusFilter.length ? classes.activeFilter : ''}
              onClick={handleClickStatus}
              aria-controls="Status-menu"
              aria-haspopup="true"
            />
          </IconButton>
        </TooltipOne>
        <DropdownMenuFilter
          anchorEl={anchorElStatus}
          setAnchorEl={setAnchorElStatus}
          menuItems={['Nowe', 'Otwarte']
            .concat(processTypeId === AssessmentSessionProcessTypeId.Scoring ? ['Ocenione'] : [])
            .concat(['Zamknięte'])}
          hasCheckbox={true}
          checkedItems={statusFilter}
          onChange={handleStatusFilterChange}
          uncheckAllMenuItems={handleStatusFilterChange}
        />
      </>
    ),
    progress: (
      <ProgressFilter
        valueName="progress"
        onChange={handleFilterChange}
        resetFilter={filter.progress === '' || filter.progress.length === 0}
        initValue={filter.progress}
      />
    ),
    alerts: (
      <ItemsFilter
        valueName="alerts"
        valueLabel="Monit"
        onChange={handleFilterChange}
        resetFilter={filter.alerts === ''}
        itemsWithImages={getAlertsMenuItems()}
        filter={filter.alerts}
      />
    ),
    verifier: (
      <VerifierFilter
        valueName="verificationState"
        valueLabel="Weryfikator"
        onChange={handleFilterChange}
        resetFilter={filter.verificationState === ''}
        filter={filter.verificationState}
        isVerifier={isVerifierInScoringProcess}
      />
    ),
    pointsSum: (
      <RangeFilter
        fromValueName="pointsFrom"
        toValueName="pointsTo"
        onChange={handleFilterChange}
        initRangeFrom={filter.pointsFrom as string}
        initRangeTo={filter.pointsTo as string}
        resetFilter={
          filter.pointsFrom === '' &&
          filter.pointsTo === '' &&
          filter.examTaskNumbersWithNoAnswer === '' &&
          advancedFilter === null
        }
        isNoAnswerFilter={!!filter.examTaskNumbersWithNoAnswer.length}
        isAdvancedFilter={advancedFilter !== null}
        additionalFlagForActiveFilter={assessmentQualityFilter.length > 0}
        onAdvancedFilterReset={onAdvancedFilterReset}
        component={
          isAllowedToFilterAssessmentQuality ? (
            <AssessmentQualityDropDownMenuFilters
              menuItems={['Ocena poza zakresem tolerancji', 'Wystąpiły rozbieżności w ocenie', 'Ocena dokładna']}
              hasCheckbox={true}
              checkedItems={assessmentQualityFilter}
              onChange={handleAssessmentQualityFilterChange}
              uncheckAllMenuItems={handleAssessmentQualityFilterChange}
              processType={processTypeId}
            />
          ) : null
        }
        noAnswerFilter={
          <div
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                handleNoAnswerFilterChange();
              }
            }}
            style={{ display: 'inline-flex', alignItems: 'center' }}
            onClick={(event) => {
              event.preventDefault();
              handleNoAnswerFilterChange();
            }}
          >
            <Checkbox
              className={classes.filterMenuCheckbox}
              checked={!!filter.examTaskNumbersWithNoAnswer.length}
              onChange={handleNoAnswerFilterChange}
            />
            Brak odpowiedzi
          </div>
        }
        advancedFilter={
          <>
            <div onClick={() => setAdvancedFilterModalOpen(true)}>
              <Typography style={{ fontSize: '13px', padding: '4px 0px 4px 70px' }}>
                Filtrowanie zaawansowane
              </Typography>
            </div>
          </>
        }
      />
    ),
    downloadDate: (
      <DateFilter
        fromValueName="downloadDateFrom"
        toValueName="downloadDateTo"
        onChange={handleFilterChange}
        resetFilter={!filter.downloadDateFrom.length && !filter.downloadDateTo.length}
        isActiveFilter={filter.downloadDateFrom.length > 0 || filter.downloadDateTo.length > 0}
        valueFrom={filter.downloadDateFrom as string}
        valueTo={filter.downloadDateTo as string}
      />
    ),
    updateDate: (
      <DateFilter
        fromValueName="updateDateFrom"
        toValueName="updateDateTo"
        onChange={handleFilterChange}
        resetFilter={!filter.updateDateFrom.length && !filter.updateDateTo.length}
        isActiveFilter={filter.updateDateFrom.length > 0 || filter.updateDateTo.length > 0}
        valueFrom={filter.updateDateFrom as string}
        valueTo={filter.updateDateTo as string}
      />
    ),
    flag: (
      <ItemsFilter
        valueName="flag"
        valueLabel="Flaga"
        onChange={handleFilterChange}
        resetFilter={filter.flag === ''}
        itemsWithImages={flagsFilter}
        filter={filter.flag}
      />
    ),
  };

  const onMainActionButtonConfirm = useCallback(() => {
    if (!examiner) throw new Error('no examiner!');

    if (mainActionButtonCallback) {
      mainActionButtonCallback();
    }
    setSendbackPromptOpen(false);
    isExaminerBlockedInSession().then((result: boolean) => setIsExaminerBlocked(result));
    setForceReloadExaminersTreemap(true);
    redirectionToProcess(assessmentSessionId, examiner.id, processTypeId).then((data) => {
      if (data && data.url) {
        history.push(data.url);
      }
    });
  }, [mainActionButtonCallback, examiner, assessmentSessionId, processTypeId]);

  const forceSelectionRef = useCallback(
    (forceSelectionCallback) => setOnForceSelectionCallback(() => forceSelectionCallback),
    [],
  );

  const isContextualHelp = useSelector((state: RootState) => state.contextualHelp.isContextualHelp);

  const [activatedContextualHelp, setActivatedContextualHelp] = useState<number | undefined>();
  const progressBar = 6;
  const tableBar = 7;

  useEffect(() => {
    dispatch(contextualHelpActions.toogleContextualHelp(false));
  }, []);

  useEffect(() => {
    const progressBarDiv = document.getElementById('progressBar');
    const contextualHelp6 = document.getElementById('contextualHelp-6');
    if (progressBarDiv && contextualHelp6) {
      contextualHelp6.style.left = progressBarDiv.offsetWidth - contextualHelp6.offsetWidth + 'px';
      contextualHelp6.style.top =
        progressBarDiv.getBoundingClientRect().top - contextualHelp6.getBoundingClientRect().top + 'px';
    }

    const tableMenu = document.getElementById('tableMenu');
    const contextualHelp7 = document.getElementById('contextualHelp-7');

    if (tableMenu && contextualHelp7) {
      contextualHelp7.style.left =
        (tableMenu.getBoundingClientRect().right - tableMenu.getBoundingClientRect().left) / 2 + 'px';
    }
  }, [isContextualHelp]);

  const openSelectedItemsInNewTabs = useCallback(() => {
    if (!examiner) {
      return;
    }

    if (itemsSelection.items.length > MAX_ITEMS_TO_BE_OPENED_IN_TABS) {
      setTooManyItemsToBeOpenedInTabsErrorOpened(true);
      return;
    }

    const tabExamTaskGroupSolutionScores = itemsSelection.items
      .map((id) => {
        const orgz = examTaskGroupSolutionsData?.find((item) => item.examTaskGroupSolutionScoreId === id);
        if (!orgz) {
          return [];
        }
        return {
          id,
          sheetId: orgz.tasksSolutionSheetId,
          examinerId: orgz.examinerId,
        };
      })
      .flat();

    dispatch(assessmentSessionActions.startTabScoring(tabExamTaskGroupSolutionScores));

    const url = getSolutionTabsUrl(processTypeStringId, examiner.id, examiner.function.toString());
    history.push(url);
  }, [itemsSelection, examTaskGroupSolutionsData, assessmentSessionId, processTypeStringId, examiner]);

  const convertLabelToSubText = (label: string): SubText => ({
    text: label,
    isBold: false,
  });

  const handleAssignVerifier = () => {
    showLoader(true, 'Przypisywanie weryfikatora');

    assignToVerifier(itemsSelection.items)
      .then((result) => {
        const { count, errors } = result.data;
        if (!errors.length) {
          setAssignedToVerifier(count);
          setIsSuccessVerifierAssignedPromptOpen(true);
        } else {
          const messages = errors
            .map((err) => (typeof err === 'string' ? err : err.message))
            .filter((message): message is AssignVerifierError => !!message);

          if (messages.includes(AssignVerifierError.NoVerifier)) {
            openAlert('error', getAssignVerifierErrorLabel(AssignVerifierError.NoVerifier));
          } else if (messages.includes(AssignVerifierError.LimitError)) {
            openAlert('error', getAssignVerifierErrorLabel(AssignVerifierError.LimitError));
          } else {
            const labels = messages.map((m: AssignVerifierError) => getAssignVerifierErrorLabel(m));
            const subTexts: SubText[] = labels.map((label: string) => convertLabelToSubText(label));
            setValidationErrorMessage(subTexts);
            setIsValidationFailedForVerifierPromptOpen(true);
          }
        }
      })
      .catch(() => {
        openAlert('error', 'Nieznany błąd. Spróbuj ponownie później.');
      })
      .finally(() => showLoader(false));
  };

  const getActionsMenuIconForSelectedRecord = useCallback(
    (selectedRecordsNumber: number): JSX.Element => {
      const items: ActionMenuItem[] = [];
      if (selectedRecordsNumber >= 2) {
        items.push({
          text: 'Otwórz w nowej zakładce',
          onClick: () => openSelectedItemsInNewTabs(),
        });
        if (examiner && isUserPZE) {
          items.push({
            text: 'Przypisz weryfikatora',
            onClick: () => handleAssignVerifier(),
          });
        }
      } else {
        if (examiner && isUserPZE) {
          items.push({
            text: 'Przypisz weryfikatora',
            onClick: () => handleAssignVerifier(),
          });
        }
      }
      return (
        <ActionsMenu menuItems={items} transformOrigin={{ horizontal: 'left', vertical: 'top' }} isNotInTable={true} />
      );
    },
    [openSelectedItemsInNewTabs, examiner],
  );

  const isInitialDownloadDisabled =
    isExaminerBlocked ||
    (examTaskGroupSolutionStatus !== undefined &&
      (isVerifierInScoringProcess
        ? ExamTaskGroupSolutionStatusDisablingDownloading.includes(examTaskGroupSolutionStatus)
        : examTaskGroupSolutionStatus === ExamTaskGroupSolutionStatus.NoneSessionClosed));

  return (
    <React.Fragment>
      <Layout viewType="examiner">
        <SnackbarDownload
          open={isSnackbarVisible}
          onClose={() => setIsSnackbarVisible(false)}
          autoHideDuration={4000}
          text={snackbarMessage}
        />
        {examiner && (
          <ViewContainer>
            <HeaderCard
              examinerName={getExaminerName()}
              sessionName={`${assessmentSession?.assessmentSessionName} / ${assessmentSession?.examTaskGroupName}`}
              isTeamList={isTeamList}
              isExaminerBlocked={isExaminerBlocked}
              processTypeId={processTypeId}
            />
            {examTaskGroupSolutions !== null &&
              (!hasAnyRealExamTaskGroupSolutions &&
              auth.profile.sub &&
              examiner &&
              examiner.examiner &&
              isEmptyList &&
              userFunction === ExaminerFunction.CZE &&
              !isVerifierInScoringProcess &&
              !(userAssessmentSessionInfo.isChairman && processTypeId === AssessmentSessionProcessTypeId.Scoring) ? (
                <DownloadCards
                  disabled={isInitialDownloadDisabled}
                  onDownload={onExamTaskGroupSolutionsDownload}
                  processTypeId={processTypeId}
                  sheetCodeWithTaskGroupName={getSheetCodeWithTaskGroupName(
                    assessmentSession?.dashboardSheetCode,
                    assessmentSession?.examTaskGroupName,
                  )}
                  onUnreadMessagesConfirm={(url) => history.push(url)}
                  pageSize={pageInfo.pageSize}
                />
              ) : !hasAnyRealExamTaskGroupSolutions &&
                isEmptyList &&
                isVerifierInScoringProcess &&
                (examTaskGroupSolutions?.length ?? 0) === 0 ? (
                <div className={classes.verifierEmptyContainer}>
                  <img src={DownloadCardsIcon} alt="ikona braku kart" />
                  <div className={classes.verifierEmptyText}>W tej chwili nie posiadasz żadnych kart.</div>
                </div>
              ) : (
                <>
                  {isContextualHelp && (
                    <div style={{ position: 'relative', left: '95%', top: '-20px' }}>
                      <ContextualHelp
                        id={progressBar}
                        isActive={activatedContextualHelp === progressBar}
                        onClick={setActivatedContextualHelp}
                        placement={'left'}
                      />
                    </div>
                  )}
                  {!(
                    isVerifierInScoringProcess ||
                    ((userFunction === ExaminerFunction.PZE ||
                      userFunction === ExaminerFunction.KGZ ||
                      userFunction === ExaminerFunction.KK) &&
                      !!examiner?.examiner?.examinerPermission?.isVerifier &&
                      processTypeId === AssessmentSessionProcessTypeId.Scoring)
                  ) && <AssessmentProgressBar {...progressBarData} processTypeId={processTypeId} />}
                  <div id="tableMenu" className={classes.menu}>
                    <div>
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {auth.profile.sub &&
                          examiner &&
                          examiner.examiner &&
                          auth.profile.sub === examiner.examiner.id &&
                          userFunction === ExaminerFunction.CZE &&
                          !isVerifierInScoringProcess &&
                          examTaskGroupSolutionStatus !== ExamTaskGroupSolutionStatus.NoneSessionClosed && (
                            <>
                              <SendbackRGZButton
                                buttonType="multiple"
                                isDisabled={!examinerHasScoreToSendback}
                                examTaskGroupSolutionScoreIds={[]}
                                sendbackFunction={handleSendbackAssessedSolutions}
                              />
                              <img className={classes.imgLine} src={Line} alt="linia pionowa" />
                              {examTaskGroupSolutionStatus !== undefined && (
                                <CardsDownloaderContainer
                                  processTypeId={processTypeId}
                                  pageSize={pageInfo.pageSize}
                                  assessmentSessionId={assessmentSession.assessmentSessionId}
                                  onDownloadFinish={handleDownloadFinish}
                                  onRender={(onDownloadStart) => {
                                    return (
                                      <Download
                                        status={examTaskGroupSolutionStatus}
                                        handleCardDownload={() => onDownloadStart(DownloadType.single)}
                                        handleCardGroupDownload={() => onDownloadStart(DownloadType.fillToLimits)}
                                      />
                                    );
                                  }}
                                ></CardsDownloaderContainer>
                              )}
                            </>
                          )}

                        {isContextualHelp && (
                          <div style={{ position: 'relative', left: '50%' }}>
                            <ContextualHelp
                              id={tableBar}
                              isActive={activatedContextualHelp === tableBar}
                              onClick={setActivatedContextualHelp}
                              placement={'right'}
                            />
                          </div>
                        )}

                        {itemsSelection.items.length !== 0 && (
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <div>
                              <SelectedRecordCountDisplay selection={itemsSelection} totalItems={pageInfo?.totalCount}>
                                {((itemsSelection.items.length !== 0 && isUserPZE) ||
                                  itemsSelection.items.length >= 2) && (
                                  <div style={{ display: 'flex' }}>
                                    <img src={Pipe} style={{ margin: '3px 5px' }} alt="ikona linia pionowa" />{' '}
                                    {getActionsMenuIconForSelectedRecord(itemsSelection.items.length)}
                                  </div>
                                )}
                              </SelectedRecordCountDisplay>
                            </div>

                            {(userFunction === ExaminerFunction.KGZ || userFunction === ExaminerFunction.KK) && (
                              <div>
                                <RemoveRGZButton
                                  isDisabled={false}
                                  examTaskGroupSolutionScoreIds={itemsSelection.items}
                                  removeRGZFunction={handleRemoveRGZFunction}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <span className={classes.pagination}>
                      <Pagination pageInfo={pageInfo} getPage={getAssessment} />
                    </span>
                  </div>
                  <div
                    className={[
                      classes.table,
                      isSidebarMinimized ? classes.tableContainerFullWidth : classes.tableContainerNarrowed,
                    ].join(' ')}
                  >
                    <SelectableTable<ExamTaskGroupSolutionsTableItem, AssessmentSortBy>
                      columns={isAllowedToFilterAssessmentQuality ? columns : columnsForExaminer}
                      rows={examTaskGroupSolutions ?? []}
                      onFilterChange={handleFilterChange}
                      filter={filter}
                      filterElements={filterElements}
                      isAdvancedFilterState={isAdvancedFilter}
                      onAdvancedFilterModalOpen={() => setAdvancedFilterModalOpen(true)}
                      onAdvancedFilterReset={onAdvancedFilterReset}
                      filterbar={filterState}
                      closeFilterItem={uncheckFilterItem}
                      uncheckAllFilters={uncheckAllFilters}
                      isMultiChoice={true}
                      onSelectionChanged={setItemsSelection}
                      forceSelectionRef={forceSelectionRef}
                      sortByProperty={sortByColumnId}
                      isDescending={isDescending}
                      setIsDescending={setIsDescending}
                      setSortByColumn={setSortByColumnId}
                      caption="Wykaz ocenianych kart"
                    />
                  </div>
                </>
              ))}
          </ViewContainer>
        )}
      </Layout>
      {currentActionOrgz && (
        <Prompt
          type="confirmation"
          open={deleteConfirmationPromptOpen}
          mainText={`Czy na pewno chcesz usunąć przypisane RGZ: ${currentActionOrgz.examTaskGroupSolutionScoreId} z ${assessmentSession.examTaskGroupName}?`}
          subTexts={[
            {
              text: '(Usunięcie przypisanego RGZ Egzaminatorowi usuwa przyznane przez niego oceny, komentarze i adnotacje.)',
            },
          ]}
          mainActionButtonText="TAK"
          onConfirm={() => {
            setDeleteConfirmationPromptOpen(false);
            removeCurrentRGZAssignment();
          }}
          onCancel={() => {
            setDeleteConfirmationPromptOpen(false);
          }}
        />
      )}
      <Prompt
        type="info"
        open={deleteSelectedExamTaskGroupSolutionsConfirmationPromptOpen}
        mainText={`Zostanie usunięte przypisanie tylko RGZ ze statusem Nowe lub Otwarte`}
        mainActionButtonText="TAK"
        onConfirm={() => {
          removeMultipleRGZAssignment();
          setDeleteSelectedExamTaskGroupSolutionsConfirmationPromptOpen(false);
        }}
        onCancel={() => {
          setDeleteSelectedExamTaskGroupSolutionsConfirmationPromptOpen(false);
        }}
      />
      {currentActionOrgz && (
        <Prompt
          type="error"
          open={deleteErrorPromptOpen}
          mainText={`Usunięcie RGZ: ${currentActionOrgz.examTaskGroupSolutionScoreId} z ${assessmentSession.examTaskGroupName} Egzaminatorowi:`}
          subTexts={[
            { text: getcurrentActionOrgzExaminerName() },
            {
              text: 'nie powiodło się, spróbuj ponownie później.',
              isBold: true,
            },
          ]}
          mainActionButtonText="POWRÓT DO LISTY"
          onConfirm={() => {
            setDeleteErrorPromptOpen(false);
          }}
        />
      )}
      <Prompt
        type="info"
        open={deleteSelectedExamTaskGroupSolutionsInfoPromptOpen}
        mainText={`Udało się usunąć ${examTaskGroupSolutionScoresDeletedCount} RGZ ze statusem Nowe lub Otwarte`}
        subTexts={
          examTaskGroupSolutionScoresNotDeletedCount
            ? [
                {
                  text: `Wśród zaznaczonych RGZ jest ${examTaskGroupSolutionScoresNotDeletedCount} ze statusem Ocenione lub Zamknięte, które nie mogą zostać usunięte`,
                },
              ]
            : []
        }
        mainActionButtonText="POWRÓT DO LISTY"
        onConfirm={() => {
          refreshData(true);
          setDeleteSelectedExamTaskGroupSolutionsInfoPromptOpen(false);
        }}
      />
      <Prompt
        type="warning"
        open={deleteSelectedExamTaskGroupSolutionsErrorPromptOpen}
        mainText={`Zaznaczone RGZ nie mogą zostać usunięte, ponieważ są w statusie Ocenione lub Zamknięte`}
        mainActionButtonText="POWRÓT DO LISTY"
        onConfirm={() => {
          setDeleteSelectedExamTaskGroupSolutionsErrorPromptOpen(false);
        }}
      />
      {tooManyItemsToBeOpenedInTabsErrorOpened && (
        <Prompt
          type="warning"
          open={true}
          mainText={`Zaznaczono za dużą liczbę RGZ do otworzenia w nowej zakładce.`}
          subTexts={[{ text: `Proszę wybrać nie więcej niż ${MAX_ITEMS_TO_BE_OPENED_IN_TABS} elementów.` }]}
          onConfirm={() => {
            setTooManyItemsToBeOpenedInTabsErrorOpened(false);
          }}
        />
      )}

      {currentActionOrgz && (
        <Prompt
          type="success"
          open={deleteSuccessPromptOpen}
          mainText={`Usunięcie RGZ: ${currentActionOrgz.examTaskGroupSolutionScoreId} z ${assessmentSession.examTaskGroupName} Egzaminatorowi:`}
          subTexts={[{ text: getcurrentActionOrgzExaminerName() }, { text: 'zakończone sukcesem.', isBold: true }]}
          mainActionButtonText="POWRÓT DO LISTY"
          onConfirm={() => {
            refreshData(true);
            setDeleteSuccessPromptOpen(false);
          }}
        />
      )}
      {
        <Prompt
          type="error"
          open={isValidationFailedForVerifierPromptOpen}
          mainText={'Nie udało się przypisać prac z następujących powodów:'}
          listItems={validationErrorMessage}
          mainActionButtonText="POWRÓT DO LISTY"
          onConfirm={() => {
            setIsValidationFailedForVerifierPromptOpen(false);
          }}
        />
      }
      {
        <Prompt
          type="success"
          open={isSuccessVerifierAssignedPromptOpen}
          mainText={`Poprawnie przypisano do weryfikacji ${assignedToVerifier} prac`}
          mainActionButtonText="POWRÓT DO LISTY"
          onConfirm={() => {
            refreshData(true);
            setIsSuccessVerifierAssignedPromptOpen(false);
          }}
        />
      }
      {currentActionOrgz && assignFlagsOpen && (
        <AssignFlags
          examTaskGroupSolutionScoreId={currentActionOrgz.examTaskGroupSolutionScoreId}
          assignedFlags={currentActionOrgz.examTaskGroupSolutionScoreFlags}
          allAvailableFlags={flags}
          onSave={() => {
            refreshData(true);
            setAssignFlagsOpen(false);
          }}
        />
      )}
      <Prompt
        size={sendbackPromptSize}
        type={sendbackPromptType}
        open={sendbackPromptOpen}
        isBold={true}
        mainText={sendbackPromptMainText}
        subTexts={sendbackPromptSubTexts}
        enhancedText={enhancedText}
        mainActionButtonText={mainActionButtonText}
        onConfirm={() => {
          onMainActionButtonConfirm();
        }}
      />
      {isExaminerBlockedPromptOpen && (
        <ExaminerBlocked isAssessmentsView={true} onClose={() => setIsExaminerBlockedPromptOpen(false)} />
      )}
      {downloadLimitModalOpen && (
        <DownloadLimitModal
          open={downloadLimitModalOpen}
          isCardLimit={examTaskGroupSolutionStatus === ExamTaskGroupSolutionStatus.NoneExceededLimits}
          noMoreCards={examTaskGroupSolutionStatus === ExamTaskGroupSolutionStatus.NoneNoMoreSolutions}
          processTypeId={processTypeId}
          handleClose={() => {
            setDownloadLimitModalOpen(false);
          }}
        />
      )}
      <SessionSuspended assessmentSessionId={assessmentSessionId} assessmentSessionStateId={assessmentSessionStateId} />
      {unreadMessagePrompt.isOpen && (
        <UnreadMessagePrompt
          action={unreadMessagePrompt.actionType}
          unreadConversationType={unreadMessagePrompt.unreadConversationType}
          sheetCodeWithTaskGroupName={getSheetCodeWithTaskGroupName(
            assessmentSession.dashboardSheetCode,
            assessmentSession.examTaskGroupName,
          )}
          onConfirm={(url) => history.push(url)}
        />
      )}
      {advancedFilterModalOpen && (
        <AdvancedFilterModal
          advancedFilter={advancedFilter}
          isResetFilter={isResetAdvancedFilter}
          checkedTasks={checkedTasks}
          setCheckedTasks={setCheckedTasks}
          checkedCriterions={checkedCriterions}
          setCheckedCriterions={setCheckedCriterions}
          setIsResetAdvancedFilter={setIsResetAdvancedFilter}
          onAdvancedFilterReset={onAdvancedFilterReset}
          assessmentSessionName={assessmentSession.assessmentSessionName}
          handleAdvancedFilterChange={handleAdvancedFilterChange}
          onClose={() => setAdvancedFilterModalOpen(false)}
        />
      )}
    </React.Fragment>
  );
};

export default Assessment;
